import { useMemo, useState } from "react";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { useActionPlansEditionContext } from "../../context/ActionPlansEditionContext";

interface IUseActionPlanStatusCellResult {
    isEditing: boolean;
    statusId: number | undefined;
    handleStatusChange: (value: number | string) => void;
}

export const useActionPlanStatusCell = (row: IActionPlan): IUseActionPlanStatusCellResult => {
    const { edit, setEdit } = useActionPlansEditionContext();

    const existingEdition = useMemo(() => edit.findIndex((e) => e.id === row.action_plan_id), [edit, row]);
    const statusIdChanges = useMemo(
        () => (existingEdition !== -1 ? edit[existingEdition]?.changes?.status_id : undefined),
        [edit, existingEdition],
    );

    const initialStatusId = statusIdChanges !== undefined ? statusIdChanges : row.status?.status_id;
    const [statusId, setStatusId] = useState<number | undefined>(initialStatusId);

    const handleStatusChange = (value: number | string) => {
        const newStatusId = typeof value === "number" ? value : Number(value);
        setStatusId(newStatusId);

        if (existingEdition !== -1) {
            setEdit((prevEdit) => {
                const newEdit = [...prevEdit];
                newEdit[existingEdition] = {
                    ...newEdit[existingEdition],
                    changes: {
                        ...newEdit[existingEdition]?.changes,
                        status_id: newStatusId,
                    },
                };
                return newEdit;
            });
        }
    };

    const isEditing = existingEdition !== -1;

    return {
        isEditing,
        statusId,
        handleStatusChange,
    };
};
